import { Badge } from "@mantine/core";
import type { PathologistReviewRowAppearance } from "./pathologistReviewQueueView";

interface PathologistQueueStateBadgeProps {
  appearance: PathologistReviewRowAppearance;
}

export function PathologistQueueStateBadge({
  appearance,
}: PathologistQueueStateBadgeProps) {
  return (
    <Badge
      color={appearance.badgeColor}
      variant={appearance.key === "rush" ? "filled" : "light"}
      size="xs"
    >
      {appearance.marker}
    </Badge>
  );
}
